module.exports = __webpack_public_path__ + "static/media/52585239_2452987921443051_6611069092298227712_o.256fb13f.jpg";